/* eslint-disable react/no-unknown-property */
import React, { FunctionComponent } from 'react';
import * as styles from './CardRowDivider.style';

const CardRowDivider: FunctionComponent = () => (
  <div css={styles.base} />
);

export default CardRowDivider;
